module.exports = __webpack_public_path__ + "static/media/image_default.50abf1fd.svg";